// extracted by mini-css-extract-plugin
module.exports = {"alert":"Error_alert__pl_Vo","container":"Error_container__1_331","heading":"Error_heading__FqF07"};